import EditorPreviewRootPage, {
    handle,
} from '~/modules/professional/page/ProfessionalPagePreview';
import { loader } from '@modules/professional/page/loaders/professional-page-preview-loader.server';

export { loader, handle };
export default EditorPreviewRootPage;
